export default "__VITE_ASSET__Bbf2tz8___"